import { render, staticRenderFns } from "./CompanyHistory.vue?vue&type=template&id=ab7c3c96&scoped=true&"
import script from "./CompanyHistory.vue?vue&type=script&lang=js&"
export * from "./CompanyHistory.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHistory.vue?vue&type=style&index=0&id=ab7c3c96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c3c96",
  null
  
)

export default component.exports